type FirebaseClientConfig = {
  apiKey: string;
  authDomain: string;
  databaseURL: string;
  projectId: string;
  storageBucket: string;
  messagingSenderId: string;
  appId: string;
};

const devConfig: FirebaseClientConfig = {
  apiKey: 'AIzaSyC-8qGQeIcHif_n11p8rnay5Ty3DAS8MPM',
  authDomain: 'my-portfolio-test.firebaseapp.com',
  databaseURL: 'https://my-portfolio-test.firebaseio.com',
  projectId: 'my-portfolio-test',
  storageBucket: 'my-portfolio-test.appspot.com',
  messagingSenderId: '789147744024',
  appId: '1:789147744024:web:47c2d4b5811a2948',
};

const stageConfig: FirebaseClientConfig = {
  apiKey: 'AIzaSyDmZvJShCG8QkKvWH9LdHHki7WAEcmvH10',
  authDomain: 'my-portfolio-stage.firebaseapp.com',
  databaseURL: 'https://my-portfolio-stage.firebaseio.com',
  projectId: 'my-portfolio-stage',
  storageBucket: 'my-portfolio-stage.appspot.com',
  messagingSenderId: '28039544859',
  appId: '1:28039544859:web:0872fec9099767b7',
};

const prodConfig: FirebaseClientConfig = {
  apiKey: 'AIzaSyCkjat8NhrG2vh9OQINvtI6aszTl5bw-KQ',
  authDomain: 'my-portfolio-prod.firebaseapp.com',
  databaseURL: 'https://my-portfolio-prod.firebaseio.com',
  projectId: 'my-portfolio-prod',
  storageBucket: 'my-portfolio-prod.appspot.com',
  messagingSenderId: '64995373132',
  appId: '1:64995373132:web:52bfc0b34120ed9e',
};

// Emulator-only. The `demo-` prefix is load-bearing, not cosmetic: the
// Firebase Emulator Suite recognizes it and refuses any attempt to reach a
// real, non-emulated backend for this project id (documented behavior,
// confirmed locally) - so this config carries no credential that could ever
// reach the real test/stage/prod projects even if the USE_EMULATORS gate in
// tools.firebase.js were somehow bypassed.
//
// `databaseURL`'s `?ns=` query param MUST be exactly `<projectId>-default-rtdb`
// - NOT the bare project id. Confirmed directly (not assumed): in the
// RTDB emulator's default "single project mode", starting it with
// `--project demo-myfolio-e2e` activates ONE real namespace,
// `demo-myfolio-e2e-default-rtdb`, with firebase/database-rules.json
// actually loaded and enforced. Requesting `?ns=demo-myfolio-e2e` (the
// bare id - the mistake this comment used to describe fixing) logs
// "Multiple projectIds are not recommended in single project mode" and
// silently creates a SECOND, improvised namespace with NO rules loaded at
// all (verified: an unauthenticated write to a rules-protected path
// succeeded there, but was correctly rejected with 401 once pointed at
// the real `-default-rtdb` namespace). Getting this wrong doesn't just
// under-test security rules - the app's realtime listeners (onValue, used
// for the portfolios list and the auth-claims-refresh listener) appear to
// never resolve at all against the mismatched namespace, hanging the app
// in a perpetual loading state.
const emulatorConfig: FirebaseClientConfig = {
  apiKey: 'fake-api-key-emulators-do-not-validate-this',
  authDomain: 'demo-myfolio-e2e.firebaseapp.com',
  databaseURL:
    'https://demo-myfolio-e2e-default-rtdb.firebaseio.com?ns=demo-myfolio-e2e-default-rtdb',
  projectId: 'demo-myfolio-e2e',
  storageBucket: 'demo-myfolio-e2e.appspot.com',
  messagingSenderId: '0',
  appId: '1:0:web:0',
};

const setupConfig = (env: string | undefined): FirebaseClientConfig => {
  switch (env) {
    case 'production':
      return prodConfig;
    case 'stage':
      return stageConfig;
    case 'development':
      return devConfig;
    case 'emulator':
      return emulatorConfig;
    default: {
      throw new Error(`[${env}] is an invalid environment.`);
    }
  }
};

export default setupConfig(process.env.APP_ENV);
